export const COLORS = {
  // Main colors of the application
  PRIMARY: '#5E809C',


  
  // Gradient colors for light theme
  LIGHT_GRADIENT_START: '#9D919F',
  LIGHT_GRADIENT_END: '#899CA8',
  
  // Gradient colors for dark theme
  DARK_GRADIENT_START: '#4C677C',
  DARK_GRADIENT_END: '#69596F',

  // Text colors
  LIGHT_TEXT: '#FEFFF4',
  DARK_TEXT: '#494949',

  // System colors
  SUCCESS: '#22c55e',
  ERROR: '#EF4444',
  WARNING: '#f59e0b',
  DISABLED: '#9ca3af',

  // Basic colors
  WHITE: '#ffffff',
  BLACK: '#000000',
  PINK: '#E94057',
  TRANSPARENT: 'transparent',

  //background for themes
  LIGHT_BACKGROUND: '#ffffff',
  DARK_BACKGROUND: '#1a1a1a',
  LIGHT_SURFACE: '#ffffff',
  DARK_SURFACE: '#2a2a2a',

  // Zinc palette (for SwipeCard)
  ZINC_900: '#18181b',
  ZINC_200: '#e5e5e5',

  // Additional UI colors
  GOLD: '#FFD700',
  GRAY_900: '#111827',
  GRAY_500: '#6b7280',
  GRAY_700 : '#494949',
  GRAY_400: '#9ca3af',

  // Semi-transparent colors
  WHITE_90: 'rgba(255,255,255,0.9)',
  WHITE_60: 'rgba(255,255,255,0.6)',
  WHITE_80: 'rgba(255,255,255,0.8)',
};
